'use client'
import { useUser } from '@/features/account/services/User/hooks'
import { getUserZip } from '@/features/account/services/User/utils'
import { isValidZip } from '@/features/shared/utils/validator'
import { inferredZipQueryOptions } from '@/features/account/services/Zip/queryOptions'
import { createPassiveQueryStore } from '@/features/shared/utils/dataFetching/createPassiveQueryStore'
import { useGuestParams } from '@/features/account/services/GuestUser/hooks'

export const useInferredZip = createPassiveQueryStore(() => inferredZipQueryOptions)

/**
 * useZip allows us to retrieve the exact same zip on both client
 * and server by accessing the cookie value. This is also reading
 * guest and user data without running into hydration issues.
 */
export const useZip = (): string | undefined => {
  const user = useUser()
  const { guestAddress } = useGuestParams() ?? {}
  const inferredZip = useInferredZip()

  let zip = user ? getUserZip(user) : guestAddress?.zip_code
  zip = zip || inferredZip || ''

  return isValidZip(zip) ? zip : undefined
}
